<template>
  <div id="contenedor-editar-infraestructura">
    <v-form v-model="formularioValido" ref="editarInfraestructura">
      <v-card>
        <v-card-title class="secondary--text">
          Editar infraestructura
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              label="Clave"
              v-model="infraestructura.clave"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>
            <custom-select
              cols="6"
              v-model="infraestructura.idTipoInfraestructura"
              label="Tipo de Infraestructura"
              :items="mixGetCatalogoInfraestructuraTipos"
              item-text="descripcion"
              item-value="id"
            >
            </custom-select>
            <custom-select
              cols="6"
              v-model="infraestructura.idSubtipoInfraestructura"
              label="Subtipo de Infraestructura"
              :items="mixGetCatalogoInfraestructuraSubtipos"
              item-text="descripcion"
              item-value="id"
            >
            </custom-select>
            <custom-text-field
              label="Descripción"
              v-model="infraestructura.descripcion"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>
            <custom-text-field cols="8" label="Dirección" v-model="infraestructura.direccion">
            </custom-text-field>
            <custom-text-field cols="4" label="Localidad" v-model="infraestructura.localidad">
            </custom-text-field>
            <custom-select
              cols="6"
              v-model="infraestructura.idEntidad"
              label="Entidad"
              :items="mixGetEntidades"
              item-text="nombre"
              item-value="id"
            >
            </custom-select>
            <custom-select
              cols="6"
              v-model="infraestructura.idMunicipio"
              label="Municipio"
              :items="mixGetMunicipios"
              item-text="nombre"
              item-value="id"
            >
            </custom-select>
            <v-col cols="12">
              <v-row no-gutters align="center">
                <v-col>
                  <span class="secondary--text font-weight-bold">
                    UBICACIONES
                  </span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="mostrarAgregarUbicacion = !mostrarAgregarUbicacion"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="secondary">mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Agregar nueva ubicación
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <ubicaciones :ubicaciones="this.puntosUbicacion"> </ubicaciones>
            </v-col>
            <custom-text-field label="Observaciones" v-model="infraestructura.observaciones">
            </custom-text-field>
            <custom-date-picker
              cols="6"
              v-model="infraestructura.fechaOrigen"
              label="Fecha de Origen"
            >
            </custom-date-picker>
            <custom-text-field
              cols="6"
              type="number"
              v-model.number="infraestructura.vidaUtilEstimados"
              label="Vida útil estimada en años"
            >
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarInfraestructura"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-dialog
      v-if="mostrarAgregarUbicacion"
      v-model="mostrarAgregarUbicacion"
      width="650"
      persistent
    >
      <agregar-ubicaciones
        v-on:agregarUbicacion="agregarUbicacion"
        v-on:cerrar="cerrarAgregarUbicaciones"
      >
      </agregar-ubicaciones>
    </v-dialog>
  </div>
</template>

<script>
import mixInfraestructura from './mixInfraestructura';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Ubicaciones from './ubicaciones/Ubicaciones.vue';
import AgregarUbicaciones from './ubicaciones/Agregar.vue';

export default {
  name: 'EditarInfraestructura',
  mixins: [mixInfraestructura],
  props: {
    infraestructuraEditar: {
      Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomDatePicker,
    CustomButton,
    Ubicaciones,
    AgregarUbicaciones,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      mostrarAgregarUbicacion: false,
      puntosUbicacion: [],
      infraestructura: {
        clave: this.infraestructuraEditar.clave,
        idTipoInfraestructura: this.infraestructuraEditar.idTipoInfraestructura,
        idSubtipoInfraestructura: this.infraestructuraEditar.idSubtipoInfraestructura,
        descripcion: this.infraestructuraEditar.descripcion,
        direccion: this.infraestructuraEditar.direccion,
        localidad: this.infraestructuraEditar.localidad,
        idMunicipio: this.infraestructuraEditar.idMunicipio,
        idEntidad: this.infraestructuraEditar.idEntidad,
        ubicacionGeografica: this.infraestructuraEditar.ubicacionGeografica,
        observaciones: this.infraestructuraEditar.observaciones,
        fechaOrigen: this.infraestructuraEditar.fechaOrigen,
        vidaUtilEstimados: this.infraestructuraEditar.vidaUtilEstimados,
      },
    };
  },
  methods: {
    setPuntosUbicacion() {
      const puntosUbicacionGeografica = JSON.parse(this.infraestructura.ubicacionGeografica);
      if (!puntosUbicacionGeografica) return;
      this.puntosUbicacion = puntosUbicacionGeografica;
    },
    agregarUbicacion(ubicacion) {
      this.puntosUbicacion.push(ubicacion);
      this.cerrarAgregarUbicaciones();
    },
    cerrarAgregarUbicaciones() {
      this.mostrarAgregarUbicacion = false;
    },
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.editarInfraestructura.reset();
    },
  },
  mounted() {
    this.setPuntosUbicacion();
  },
};
</script>

<style lang="scss" scoped></style>
